const common = {
  // Nav
  nav_home: "Home",
  nav_tracking: "Track Parcel",
  nav_admin: "Admin",
  nav_brand: "Sonic Express Services",

  // Home
  home_hero_title: "Track Your Parcel",
  home_hero_subtitle: "Real-time tracking for your shipments worldwide",
  home_search_placeholder: "SE-000000000",
  home_search_btn: "Track Now",
  home_features_title: "Why Choose Sonic Express Services?",
  home_feature1_title: "Real-Time Updates",
  home_feature1_desc: "Get live status updates for your parcel at every step of the journey.",
  home_feature2_title: "Global Coverage",
  home_feature2_desc: "Track shipments across 200+ countries and territories worldwide.",
  home_feature3_title: "Instant Alerts",
  home_feature3_desc: "Receive notifications when your parcel status changes.",
  home_stats_parcels: "Parcels Tracked",
  home_stats_countries: "Countries Covered",
  home_stats_satisfaction: "Customer Satisfaction",
  home_recent_title: "Recent Tracking",
  home_no_recent: "No recent tracking history",
  home_track_another: "Track Another Parcel",

  // Parcel Details
  parcel_title: "Parcel Details",
  parcel_tracking_number: "Tracking Number",
  parcel_status: "Status",
  parcel_sender: "Sender",
  parcel_recipient: "Recipient",
  parcel_weight: "Weight",
  parcel_dimensions: "Dimensions",
  parcel_origin: "Origin",
  parcel_destination: "Destination",
  parcel_current_location: "Current Location",
  parcel_estimated_delivery: "Estimated Delivery",
  parcel_phone: "Mobile Phone",
  parcel_delivery_address: "Delivery Address",
  parcel_timeline_title: "Shipment Timeline",
  parcel_not_found: "Parcel Not Found",
  parcel_not_found_desc: "We couldn\'t find a parcel with that tracking number. Please check and try again.",
  parcel_back_home: "Back to Home",
  parcel_map_title: "Current Location",
  parcel_info_title: "Shipment Information",

  // Status labels
  status_processing: "Processing",
  status_in_transit: "In Transit",
  status_out_for_delivery: "Out for Delivery",
  status_delivered: "Delivered",
  status_exception: "Exception",

  // Admin
  admin_title: "Admin Dashboard",
  admin_subtitle: "Manage all parcels and their tracking information",
  admin_add_parcel: "Add New Parcel",
  admin_search_placeholder: "Search by tracking number or recipient...",
  admin_col_tracking: "Tracking ID",
  admin_col_recipient: "Recipient",
  admin_col_status: "Status",
  admin_col_location: "Current Location",
  admin_col_updated: "Last Updated",
  admin_col_actions: "Actions",
  admin_edit: "Edit",
  admin_delete: "Delete",
  admin_save: "Save Changes",
  admin_cancel: "Cancel",
  admin_confirm_delete: "Are you sure you want to delete this parcel?",
  admin_modal_add_title: "Add New Parcel",
  admin_modal_edit_title: "Edit Parcel",
  admin_field_tracking: "Tracking Number",
  admin_field_status: "Status",
  admin_field_sender: "Sender",
  admin_field_recipient: "Recipient",
  admin_field_weight: "Weight",
  admin_field_dimensions: "Dimensions",
  admin_field_origin: "Origin",
  admin_field_destination: "Destination",
  admin_field_location: "Current Location",
  admin_field_phone: "Mobile Phone",
  admin_field_delivery_address: "Delivery Address",
  admin_field_lat: "Latitude",
  admin_field_lng: "Longitude",
  admin_field_estimated: "Estimated Delivery",
  admin_total_parcels: "Total Parcels",
  admin_in_transit: "In Transit",
  admin_delivered: "Delivered",
  admin_processing: "Processing",
  admin_no_parcels: "No parcels found",
  admin_password_label: "Admin Password",
  admin_password_placeholder: "Enter admin password",
  admin_login_btn: "Login",
  admin_login_title: "Admin Login",
  admin_login_error: "Incorrect password. Please try again.",
  admin_logout: "Logout",

  // Footer
  footer_desc: "Your trusted partner for global parcel tracking and logistics solutions.",
  footer_quick_links: "Quick Links",
  footer_contact: "Contact Us",
  footer_email: "sonicexpresservices@gmail.com",
  footer_rights: "All rights reserved.",
  footer_privacy: "Privacy Policy",
  footer_terms: "Terms of Service",

  // Tracking page hardcoded strings
  tracking_number_label: "Tracking Number",
  tracking_live_active: "Live tracking active",
  tracking_delivery_details: "Delivery Details",
  tracking_shipment_info: "Shipment Info",
  tracking_looking_up: "Looking up your parcel...",
  tracking_checking: "Checking tracking number",
  tracking_invalid_format: "Invalid Tracking Number Format",
  tracking_invalid_desc: "The tracking number is not in the correct format.",
  tracking_invalid_format_hint: "Sonic Express tracking numbers follow the format:",
  tracking_invalid_copy_hint: "Make sure you copied the full tracking number exactly as provided, including the SE- prefix.",
  tracking_try_again: "Try Again",
  tracking_not_registered: "Parcel Not Registered",
  tracking_not_registered_desc: "The tracking number is not registered or known in our system.",
  tracking_not_registered_hint: "Please double-check your tracking number or contact the sender to confirm the shipment has been registered.",

  // Shipment progress stage labels
  stage_processing: "Processing",
  stage_in_transit: "In Transit",
  stage_out_for_delivery: "Out for Delivery",
  stage_delivered: "Delivered",
  progress_current_location: "Current Location",
  progress_action_required: "Action May Be Required",
  progress_exception_desc: "Your parcel may be undergoing customs clearance or require additional documentation. Our team is looking into it — please reach out to support for the latest update.",
  progress_complete: "complete",

  // Timeline
  timeline_origin: "Origin",
  timeline_destination: "Destination",
  timeline_live: "Live",

  // Language
  lang_en: "English",
  lang_zh: "中文",
  lang_th: "ภาษาไทย",
};

export default common;
